module.exports = __webpack_public_path__ + "static/media/shirtBlackWhite.c9ad1712.jpg";